import { DrawSetting, DrawTool } from '@agissc/ktag-map';
import useAppState from '../../../AppStore';

const DISPLAYED_SLIDERS: Record<
  Exclude<DrawTool, 'selection'>,
  Exclude<
    DrawSetting,
    DrawSetting.Color | DrawSetting.DisplayTooltip | DrawSetting.FilledOut
  >[]
> = {
  dot: [DrawSetting.Radius, DrawSetting.Opacity],
  line: [DrawSetting.StrokeWidth, DrawSetting.Opacity],
  polygon: [DrawSetting.StrokeWidth, DrawSetting.Opacity],
  arrow: [DrawSetting.StrokeWidth, DrawSetting.Opacity],
  circle: [DrawSetting.StrokeWidth, DrawSetting.Opacity],
  text: [DrawSetting.FontSize, DrawSetting.Opacity],
};

const useDrawSliders = () => {
  const drawFeatures = useAppState((state) => state.drawFeatures);
  const selectedFeatureId = useAppState((state) => state.selectedFeatureId);

  const feature = drawFeatures.find((f) => f.id === selectedFeatureId)!;
  const type = feature?.properties.type as Exclude<DrawTool, 'selection'>;

  const displayedSliders = DISPLAYED_SLIDERS[type];

  const displayRadius = type === 'circle';

  const displayCoordinates = type === 'dot';

  const displayFilledOut = ['circle', 'polygon'].includes(type);

  const displayText = type === 'text';

  return {
    displayedSliders,
    displayRadius,
    displayFilledOut,
    feature,
    displayCoordinates,
    displayText,
  };
};

export default useDrawSliders;
